<template>
  <img
    :src="icon"
    :data-testid="`icon-${name}`"
    :style="iconStyle"
    alt="icon"
    class="icon"
    :class="{ disabled: props.disabled }"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import * as icons from '@/components/common/icons/index'

interface Props {
  name: string
  disabledName?: string
  hoverName?: string
  disabled?: boolean
  iconHeight?: number
}

const props = defineProps<Props>()

const isHovered = ref(false)
const icon = computed(() => {
  if (props.disabled && props.disabledName) {
    return icons[props.disabledName as keyof typeof icons]
  }
  if (isHovered.value && props.hoverName) {
    return icons[props.hoverName as keyof typeof icons]
  }
  return icons[props.name as keyof typeof icons]
})
const iconStyle = computed(() => {
  const style: Record<string, string> = {}
  if (props.iconHeight) {
    style.height = `${props.iconHeight}px`
  }
  return style
})
</script>

<style lang="scss" scoped>
.icon {
  vertical-align: middle;
  transition: opacity 0.2s ease-in-out;

  &.disabled {
    pointer-events: none;
  }
}
</style>
